import { z } from "zod";

export const PrintTemplateTypeSchema = z.enum([
  "tax_receipt",
  "kitchen_ticket",
]);

export type PrintTemplateType = z.infer<typeof PrintTemplateTypeSchema>;

export interface PrintTemplate {
  id: number;
  shop_id: number;
  type: PrintTemplateType;
  name: string;
  template: string;
}

export interface CreatePrintTemplateData {
  type: PrintTemplateType;
  name: string;
  template: string;
}

export interface UpdatePrintTemplateData {
  type?: PrintTemplateType;
  name?: string;
  template?: string;
}

export interface PrintTemplateFilters {
  type?: PrintTemplateType;
}

export interface PrintTemplatePreviewInput {
  type: PrintTemplateType;
  name: string;
  template: string;
}

export interface PrintTemplatePreviewResult {
  svg: string;
}
